<div class="add-visual-modal">
    <aside class="add-visual-modal__menu">
        <app-sidemenu [nodes]="menuItems" [selectedNodeId]="selectedMenuId" (nodeSelect)="onMenuSelected($event)">
        </app-sidemenu>
    </aside>

    <section class="add-visual-modal__content">
        <div [hidden]="selectedMenuId !== 'ask'" class="add-visual-modal__pane">
            <app-ask-panel
                #askPanel
                title="What visual would you like to add?"
                description="Use plain language. You can review the result in Visual Editor."
                placeholder="Add a bar chart showing application count by PADU status"
                helperText="ASK will create the visual title and select the best chart type."
                [selectedElementType]="selectedElementType"
                [reportId]="reportId"
                [(value)]="askPromptValue" (generated)="onAskGenerated($event)"
                (proceedToVisualEditor)="selectedMenuId = 'visual-editor'">
            </app-ask-panel>
        </div>

        <div [hidden]="selectedMenuId !== 'visual-editor'" class="add-visual-modal__pane">
            <app-add-visual [draft]="visualElements" [selectedDataSource]="selectedDataSource"
                [availableFilters]="appliedFilterOptions" [currentVisualCount]="currentVisualCount"
                [hasReportAdminRole]="hasReportAdminRole" [visualTypeLabel]="visualTypeLabel"
                [heading]="draft.title" (headingChange)="onVisualHeadingChange($event)"
                [chartOrder]="draft.order" (chartOrderChange)="onChartOrderChange($event)"
                [chartWidth]="draft.width" (chartWidthChange)="onChartWidthChange($event)"
                (draftChange)="onVisualDraftChange($event)"></app-add-visual>
        </div>

        <div [hidden]="selectedMenuId !== 'json-editor'" class="add-visual-modal__pane">
            <app-json-editor #visualJsonEditor [initialJson]="jsonEditorInitialJson" jsonType="other"
                [showActionButtons]="false"
                (jsonTextChange)="onJsonTextChange($event)" (constructedQueryChange)="onConstructedQueryChange($event)"
                (jsonValidated)="onJsonValidated($event)">
            </app-json-editor>
        </div>

        <div [hidden]="selectedMenuId !== 'sql-query'" class="add-visual-modal__pane add-visual-modal__pane--full">
            <app-visual-code [constructedQuery]="sqlQueryCode"></app-visual-code>
        </div>
    </section>
</div>
